/* Lummiwell custom section scripts (original). */
(function () {
  function moneyFormat(el) {
    var s = el && el.querySelector('[data-lw-money]') || document.querySelector('[data-lw-money]');
    try { return s ? JSON.parse(s.textContent) : '${{amount}}'; } catch (e) { return '${{amount}}'; }
  }
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    function fmt(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return String(format).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* Sliders: dots + optional autoplay (banner, mini reviews) */
  function slideIndex(track) {
    var best = 0, bestD = Infinity;
    Array.prototype.forEach.call(track.children, function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < bestD) { bestD = d; best = i; } });
    return best;
  }
  function goTo(track, i) { var s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
  document.querySelectorAll('[data-lw-slider]').forEach(function (track) {
    var dots = track.parentElement.querySelector('[data-lw-dots]');
    var n = track.children.length;
    if (dots && n > 1) {
      for (var i = 0; i < n; i++) (function (i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', function () { goTo(track, i); });
        dots.appendChild(b);
      })(i);
      var mark = function () { var c = slideIndex(track); Array.prototype.forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', j === c); }); };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); });
      mark();
    }
    var secs = Number(track.dataset.lwAutoplay);
    if (secs && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var paused = false;
      track.addEventListener('pointerenter', function () { paused = true; });
      track.addEventListener('pointerleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () { if (!paused && !document.hidden) goTo(track, (slideIndex(track) + 1) % n); }, secs * 1000);
    }
  });


  /* Prev/next buttons for sliders */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lw-slide-prev],[data-lw-slide-next]');
    if (!b) return;
    var wrap = b.closest('[data-lw-ba-slider]') || b.parentElement.parentElement;
    var track = wrap.querySelector('[data-lw-slider]');
    if (!track) return;
    var first = track.children[0], gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var stepW = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    var dir = b.hasAttribute('data-lw-slide-next') ? 1 : -1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (dir > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
    else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    else track.scrollBy({ left: dir * stepW, behavior: 'smooth' });
  });


  /* Center before/after arrows on the picture */
  function lwBaArrows() {
    document.querySelectorAll('[data-lw-ba-slider].is-multi').forEach(function (s) {
      var img = s.querySelector('.lw-ba'); if (img) s.style.setProperty('--lw-ba-arrow-top', (img.offsetTop + img.offsetHeight / 2) + 'px');
    });
  }
  lwBaArrows(); window.addEventListener('resize', lwBaArrows); window.addEventListener('load', lwBaArrows);

  /* Card slider arrows */
  document.querySelectorAll('[data-lw-cards-nav]').forEach(function (nav) {
    var track = nav.parentElement.querySelector('.lw-cards');
    var prev = nav.querySelector('[data-lw-prev]'), next = nav.querySelector('[data-lw-next]');
    function step() { var c = track.children[0]; var gap = parseFloat(getComputedStyle(track).columnGap) || 20; return c ? c.getBoundingClientRect().width + gap : track.clientWidth; }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      nav.hidden = track.scrollWidth <= track.clientWidth + 2;
      var w = nav.closest('[data-lw-cards-wrap]'); if (w) w.classList.toggle('has-nav', !nav.hidden);
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    window.addEventListener('resize', update);
    update();
  });

  document.addEventListener('click', function (e) {
    /* Video sound toggle */
    var snd = e.target.closest('[data-lw-sound]');
    if (snd) {
      var v = snd.parentElement.querySelector('video');
      if (v) { v.muted = !v.muted; if (!v.muted) v.play(); var ic = snd.querySelector('.lw-icon'); if (ic) ic.textContent = v.muted ? 'volume_off' : 'volume_up'; }
      return;
    }
    /* Tabs */
    var tab = e.target.closest('[data-lw-tab]');
    if (tab) {
      var root = tab.closest('[data-lw-tabs]');
      root.querySelectorAll('[data-lw-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      root.querySelectorAll('[data-lw-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.lwPanel === tab.dataset.lwTab); });
      return;
    }
    /* Sticky add to cart */
    var sb = e.target.closest('[data-lw-sticky-btn]');
    if (sb) {
      var form = document.getElementById(sb.dataset.form);
      var btn = form && form.querySelector('[type="submit"]');
      if (btn) btn.click(); else if (form) form.requestSubmit();
      return;
    }
    /* Bundle add */
    var ba = e.target.closest('[data-lw-bundle-add]');
    if (ba) {
      var bundle = ba.closest('[data-lw-bundle]');
      var items = Array.prototype.map.call(bundle.querySelectorAll('input[data-variant]:checked'), function (i) { return { id: Number(i.dataset.variant), quantity: 1 }; });
      if (!items.length) return;
      ba.setAttribute('aria-busy', 'true'); ba.disabled = true;
      var root2 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root2 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error(); window.location.href = root2 + 'cart'; })
        .catch(function () { ba.disabled = false; ba.removeAttribute('aria-busy'); var er = bundle.querySelector('[data-lw-bundle-error]'); if (er) er.hidden = false; });
    }
  });

  /* Before / after */
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-lw-ba-range]')) { var ba = e.target.closest('[data-lw-ba]'); ba.style.setProperty('--lw-pos', e.target.value + '%'); ba.classList.add('is-touched'); }
  });

  /* Track order */
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-lw-track]')) return;
    e.preventDefault();
    var n = e.target.querySelector('[name="number"]').value.trim();
    if (n) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
  });

  /* Bundle totals */
  function bundleTotals(bundle) {
    var f = moneyFormat(bundle.parentElement);
    var sum = 0;
    bundle.querySelectorAll('input[data-variant]:checked').forEach(function (i) { sum += Number(i.dataset.price); });
    var off = Number(bundle.dataset.discount) || 0;
    var pay = Math.round(sum * (100 - off) / 100);
    bundle.querySelector('[data-lw-bundle-total]').textContent = formatMoney(pay, f);
    var c = bundle.querySelector('[data-lw-bundle-compare]');
    c.hidden = !(off > 0); c.textContent = formatMoney(sum, f);
  }
  document.querySelectorAll('[data-lw-bundle]').forEach(function (b) {
    bundleTotals(b);
    b.addEventListener('change', function () { bundleTotals(b); });
  });

  /* Quantity breaks */
  function renderBreaks(root) {
    var f = moneyFormat(root);
    var price = Number(root.dataset.price), compare = Math.max(Number(root.dataset.compare) || 0, price);
    root.querySelectorAll('[data-lw-break]').forEach(function (el) {
      var q = Number(el.dataset.qty), off = Number(el.dataset.off) || 0;
      var full = price * q, pay = Math.round(full - full * off / 100), cmp = q > 1 ? price * q : compare * q;
      if (el.dataset.fixedPay) pay = Number(el.dataset.fixedPay);
      if (el.dataset.fixedCmp && q === 1) cmp = Number(el.dataset.fixedCmp);
      var saved = cmp - pay;
      el.querySelector('[data-lw-pay]').textContent = formatMoney(pay, f);
      var c = el.querySelector('[data-lw-cmp]'); if (c) { c.textContent = formatMoney(cmp, f); c.hidden = cmp <= pay; }
      var cap = el.querySelector('[data-lw-caption]');
      if (cap) { cap.textContent = cap.dataset.lwCaption.replace('[amount_saved]', formatMoney(saved, f)); cap.hidden = saved <= 0; }
    });
  }
  function initBreaks(root) {
    var hidden = root.querySelector('[data-lw-breaks-qty]');
    function sync() {
      var checked = root.querySelector('input[type="radio"]:checked') || root.querySelector('input[type="radio"]');
      if (!checked) return;
      checked.checked = true;
      root.querySelectorAll('[data-lw-break]').forEach(function (l) { l.classList.toggle('is-selected', l.contains(checked)); });
      hidden.value = checked.value;
    }
    root.addEventListener('change', sync);
    sync();
  }
  document.querySelectorAll('[data-lw-breaks]').forEach(initBreaks);

  /* Delivery timeline dates */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(n) { var d = new Date(); d.setDate(d.getDate() + n); return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  document.querySelectorAll('[data-lw-ship] .lw-ship__step').forEach(function (s) {
    var t = s.querySelector('[data-lw-ship-text]');
    var min = Number(s.dataset.min) || 0, max = Math.max(Number(s.dataset.max) || 0, min);
    t.innerHTML = t.dataset.lwShipText.replace('[start_date]', addDays(min)).replace('[end_date]', addDays(max));
  });

  /* Sticky add to cart: show after main button scrolls out of view */
  document.querySelectorAll('[data-lw-sticky]').forEach(function (bar) {
    var form = document.getElementById(bar.querySelector('[data-lw-sticky-btn]').dataset.form);
    var target = form && (form.querySelector('[type="submit"]') || form);
    if (!target || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar);
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(target);
  });


  /* Variant bundle cards: select a variant by card */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lw-vcards] input[type="radio"]');
    if (!input) return;
    var root = input.closest('[data-lw-vcards]');
    root.querySelectorAll('[data-lw-break]').forEach(function (l) { l.classList.toggle('is-selected', l.contains(input)); });
    var form = document.getElementById(root.dataset.form);
    if (form) { var id = form.querySelector('[name="id"]'); if (id) { id.value = input.value; id.disabled = false; id.dispatchEvent(new Event('change', { bubbles: true })); } }
    var f = moneyFormat(root), price = Number(input.dataset.price), cmp = Number(input.dataset.compare) || 0;
    var pr = document.getElementById('price-' + root.dataset.section);
    if (pr) {
      var box = pr.querySelector('.price');
      if (box) box.classList.toggle('price--on-sale', cmp > price);
      pr.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (el) { el.textContent = formatMoney(price, f); });
      pr.querySelectorAll('.price__sale s.price-item--regular').forEach(function (el) { el.textContent = formatMoney(cmp, f); });
    }
    document.querySelectorAll('.lw-sticky__price').forEach(function (p) { p.textContent = formatMoney(price, f); });
    document.querySelectorAll('.lw-sticky__compare').forEach(function (c) { c.hidden = !(cmp > price); c.textContent = formatMoney(cmp, f); });
    try { var u = new URL(window.location.href); u.searchParams.set('variant', input.value); history.replaceState({}, '', u.toString()); } catch (err) {}
  });


  /* Free gifts: unlock by selected quantity */
  function currentQty() {
    var b = document.querySelector('[data-lw-breaks-qty]');
    if (b) return Number(b.value) || 1;
    var q = document.querySelector('.product-form__quantity input[name="quantity"], quantity-input input[name="quantity"]');
    return q ? Number(q.value) || 1 : 1;
  }
  function updateGifts() {
    var q = currentQty();
    document.querySelectorAll('[data-lw-gifts] .lw-gift').forEach(function (g) { g.classList.toggle('is-unlocked', q >= Number(g.dataset.qty)); });
  }
  if (document.querySelector('[data-lw-gifts]')) {
    document.addEventListener('change', function () { setTimeout(updateGifts, 0); });
    document.addEventListener('click', function (e) { if (e.target.closest('quantity-input, [data-lw-breaks]')) setTimeout(updateGifts, 0); });
    document.addEventListener('input', updateGifts);
    updateGifts();
  }

  /* Keep prices in sync when the variant changes (Dawn pub/sub) */
  function onVariant(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-lw-breaks]').forEach(function (r) {
      r.dataset.price = variant.price; r.dataset.compare = variant.compare_at_price || 0; renderBreaks(r);
    });
    document.querySelectorAll('.lw-sticky__price').forEach(function (p) { p.textContent = formatMoney(variant.price, moneyFormat(document)); });
    document.querySelectorAll('.lw-sticky__compare').forEach(function (c) { var cp = Number(variant.compare_at_price) || 0; c.hidden = !(cp > variant.price); c.textContent = formatMoney(cp, moneyFormat(document)); });
  }
  window.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        onVariant(event.data && event.data.variant);
        // Dawn may re-render the product info; re-init breaks inside new HTML
        setTimeout(function () { document.querySelectorAll('[data-lw-breaks]').forEach(function (r) { if (!r.dataset.lwInit) { r.dataset.lwInit = 1; initBreaks(r); } renderBreaks(r); }); }, 50);
      });
    }
  });
  document.querySelectorAll('[data-lw-breaks]').forEach(function (r) { r.dataset.lwInit = 1; });
})();

/* Countdown to local midnight (used in the cart drawer) */
if (!customElements.get('lw-countdown')) {
  customElements.define('lw-countdown', class extends HTMLElement {
    connectedCallback() { this.tick(); this.timer = setInterval(this.tick.bind(this), 1000); }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var h = pad(Math.floor(s / 3600)), m = pad(Math.floor(s % 3600 / 60)), sec = pad(s % 60);
      if (this.dataset.style === 'boxes') {
        var H = this.querySelector('[data-h]'), M = this.querySelector('[data-m]'), S2 = this.querySelector('[data-s]');
        if (H) H.textContent = h; if (M) M.textContent = m; if (S2) S2.textContent = sec;
      } else { this.textContent = h + ':' + m + ':' + sec; }
    }
  });
}

/* Play videos only while they are on screen (saves data and keeps scrolling smooth) */
(function () {
  var vids = document.querySelectorAll('video.lw-autovideo');
  if (!vids.length) return;
  function play(v) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else if (!e.target.paused) e.target.pause(); });
  }, { rootMargin: '150px 0px', threshold: 0.05 });
  vids.forEach(function (v) { io.observe(v); });
})();
